<script>
import { mapState } from 'vuex'
import _ from 'lodash'
  export default {
    name: 'DataTable',
    props: ['headers', 'items', 'itemsPerPage', 'name'],
    model: {
      get() {
        return this.$store.state[this.form][this.field]
      },
      set(v) {
        this.$store.dispatch(`${ this.form }/SET_FIELD`, { key: this.field, value: v })
      },
    },
    data(){
      return {
        pathName(item){
          return _.capitalize(item)
        }
      }
    },
    computed: {
      ...mapState({
        siteTypes: state => state.siteFilter.siteTypes,
        statusTypes: state => state.search.statusTypes
      }),
    },
    methods: {
      typeID(id){
        const type = this.siteTypes.filter( type => type.ID == id)
        return type[0].Name
      },
      getRowStatus: function(statusCode) {
        const status = this.statusTypes.filter( type => type.ID == statusCode)
        return status[0].Name
      }
    }
  }
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page=" itemsPerPage || 10"
  >
    <template v-slot:item.ID=" { item }" >
      <span>
        <router-link :to="{ name: pathName(item.vo) , params: { id: item.ID } }">
          {{ item.ID }}
        </router-link>
      </span>
    </template>
    <template v-slot:item.RowStatus=" { item }" >
      <span>
        {{ getRowStatus( item.RowStatus ) }}
      </span>
    </template>
    <template v-slot:item.TypeID=" { item }" >
      <span>
        {{ typeID(item.TypeID) }}
      </span>
    </template>

  </v-data-table>
</template>
